import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MenuInfoContext } from '../../../home/MenuInfoContext';
import MenuDialog from '../../../Catering/Components/CateringEvent/Components/MenuSelection/MenuDialog';
import FoodDialog from '../../../Catering/Components/CateringEvent/Components/MenuSelection/FoodDialog';
import { cloneDeep } from 'lodash';
import { RestauInfoContext } from '../../../home/RestauInfoContext';
import useOrder from '../../../Catering/Components/CateringEvent/Components/MenuSelection/useOrder';
import AiTrainingDataContext from '../../AiTrainingDataContext';
import CustomFoodDialog from '../../../Catering/Components/CateringEvent/Components/MenuSelection/CustomFoodDialog';

function EditFoodItemsInOrder(props) {
    const {
        rowId,
        openMenuDialog,
        setOpenMenuDialog,
        updateOrderSummaryForRow,
        removeItemFromOrderSummaryForRow,
        updateTranscriptionTextForRow,
    } = props;

    const {
        orders,
        dispatchOrder,
        openFood,
        setOpenFood,
        menuLoading,
        setMenuLoading,
        //updateMenuSelection,
    } = useOrder();

    const { callRecAndTrainingData } = useContext(AiTrainingDataContext);
    const [menu, setMenu] = useState(null);
    const [defaultTax, setDefaultTax] = useState(0);
    const [openFoodDialog, setOpenFoodDialog] = useState(false);
    const [openCustomFoodDialog, setOpenCustomFoodDialog] = useState(false);
    const [keyToEdit, setKeyToEdit] = useState(null);

    const menuHook = useContext(MenuInfoContext);
    const { restauHook } = useContext(RestauInfoContext);

    const callRecAndTrainingDataToDisplay = callRecAndTrainingData.find(
        (x) => x.id === rowId
    );

    const refreshMenu = async () => {
        console.log('Refreshin Menu..');
        setMenuLoading(true);
        try {
            await menuHook.refreshData();
            console.log('MenuHook: ', menuHook);
            if (menuHook.value) {
                if (menuHook.value.menu) setMenu(menuHook.value.menu);
                if (menuHook.value.payments)
                    setDefaultTax(menuHook.value.payments.salesTax);
                if (menuHook.value.modifiers) processModifiers();
            }
        } catch (e) {
            console.log('Error in refreshing menu: ', e);
        } finally {
            setMenuLoading(false);
        }
    };

    const processModifiers = () => {
        let newMenu = cloneDeep(menuHook.value.menu);
        for (const [section_idx, section] of Object.entries(newMenu)) {
            if (!section.foods) continue;
            for (const [food_idx, food] of Object.entries(section.foods)) {
                if (food['modifiers']) {
                    let modifierGroup = {};
                    modifierGroup['modifiers'] = [];
                    for (let mod of food['modifiers']) {
                        let modf = { ...menuHook.value.modifiers[mod] };
                        modifierGroup['modifiers'].push(modf);
                    }
                    food['modifierGroup'] = modifierGroup;
                }
            }
        }
        setMenu(newMenu);
    };

    const updatePricing = (orderToUpdate, currItems) => {
        let newOrderToUpdate;
        if (Object.keys(currItems).length === 0) {
            newOrderToUpdate = {
                ...orderToUpdate,
                items: currItems,
                payment_subtotal_original: 0,
                payment_subtotal_before_discount: 0,
                payment_subtotal: 0,
                payment_salestax: 0,
                payment_salestax_percent: defaultTax,
                payment_total: 0,
                tip: 0,
            };
        } else {
            let original_subtotal = 0;
            let subtotal = 0;
            let salestax_percent = orderToUpdate
                ? orderToUpdate.payment_salestax_percent
                : defaultTax;
            for (let key in currItems) {
                let item = currItems[key];
                original_subtotal += item.quantity * item.original_price;
                subtotal += item.quantity * item.price;
            }
            let discount_amount = orderToUpdate.discount.amount;
            if (orderToUpdate.discount.discount_type === 'Percent') {
                discount_amount = Math.round(
                    (subtotal * orderToUpdate.discount.percent_off) / 100
                );
            }
            newOrderToUpdate = {
                ...orderToUpdate,
                discount: {
                    ...orderToUpdate.discount,
                    amount: discount_amount,
                },
                items: currItems,
                payment_subtotal_original: original_subtotal,
                payment_subtotal_before_discount: subtotal,
                payment_subtotal: subtotal - discount_amount,
                payment_salestax: Math.round(
                    (salestax_percent / 100) * (subtotal - discount_amount)
                ),
                payment_salestax_percent: salestax_percent,
                payment_total: Math.round(
                    (subtotal - discount_amount) * (1 + salestax_percent / 100)
                ),
                tip: 0,
            };
        }
        return newOrderToUpdate;
    };

    const updateMenuSelection = async (orders) => {
        //console.log('Order Details: ', orders);
        //debugger;
        updateOrderSummaryForRow(rowId, Object.values(orders.items));
    };

    const removeItemFromOrder = async (rowId, key) => {
        //debugger;
        removeItemFromOrderSummaryForRow(rowId, key);
    };

    useEffect(() => {
        refreshMenu();
    }, [restauHook.restauId]);

    useEffect(() => {
        if (menuHook.value) {
            if (menuHook.value.menu) setMenu(menuHook.value.menu);
            if (menuHook.value.payments)
                setDefaultTax(menuHook.value.payments.salesTax);
            if (menuHook.value.modifiers) processModifiers();
        }
    }, [menuHook]);

    return (
        <>
            {openMenuDialog && menuHook && (
                <MenuDialog
                    open={openMenuDialog}
                    setOpenMenuDialog={setOpenMenuDialog}
                    setOpenFood={setOpenFood}
                    menu={menu}
                    setOpenFoodDialog={setOpenFoodDialog}
                    setOpenCustomFoodDialog={setOpenCustomFoodDialog}
                    //NOTE: for CallRecording and Training view only
                    // uncomment the below line to enable viewing & editing order details in the popup
                    callRecAndTrainingDataToDisplay={
                        callRecAndTrainingDataToDisplay
                    }
                    rowId={rowId}
                    removeItemFromOrder={removeItemFromOrder}
                    updateTranscriptionTextForRow={
                        updateTranscriptionTextForRow
                    }
                />
            )}
            {openFood && (
                <FoodDialog
                    open={openFoodDialog}
                    setOpenFoodDialog={setOpenFoodDialog}
                    orders={orders}
                    dispatchOrder={dispatchOrder}
                    openFood={openFood}
                    setOpenFood={setOpenFood}
                    menuLoading={menuLoading}
                    updateMenuSelection={updateMenuSelection}
                    defaultTax={defaultTax}
                    updatePricing={updatePricing}
                    keyToEdit={keyToEdit}
                    setKeyToEdit={setKeyToEdit}
                    orderType="PhoneViaAI"
                />
            )}

            {openCustomFoodDialog && (
                <CustomFoodDialog
                    open={openCustomFoodDialog}
                    setOpenCustomFoodDialog={setOpenCustomFoodDialog}
                    orders={orders}
                    dispatchOrder={dispatchOrder}
                    openFood={openFood}
                    setOpenFood={setOpenFood}
                    updateMenuSelection={updateMenuSelection}
                    defaultTax={defaultTax}
                    updatePricing={updatePricing}
                    keyToEdit={keyToEdit}
                    setKeyToEdit={setKeyToEdit}
                />
            )}
        </>
    );
}

EditFoodItemsInOrder.propTypes = {
    rowId: PropTypes.string.isRequired,
    updateOrderSummaryForRow: PropTypes.func.isRequired,
    openMenuDialog: PropTypes.bool.isRequired,
    setOpenMenuDialog: PropTypes.func.isRequired,
    removeItemFromOrderSummaryForRow: PropTypes.func.isRequired,
    updateTranscriptionTextForRow: PropTypes.func,
};

export default EditFoodItemsInOrder;
